
export function getNameFromTitle(title: string): string {
  const titleParts = title.split('(');

  return titleParts[0].trim();
}
